// extracted by mini-css-extract-plugin
module.exports = {"popover":"DecisionHistoryButton-popover-261362d83ccfadf6963be93d2ad3620f","historyIcon":"DecisionHistoryButton-historyIcon-d7a2bdbfab079bc87499dc572e5f56f0"};